import type { ReactNode } from "react";
import type { DetailJsonBlock } from "./type";

export interface TitleBlockProps {
    item: DetailJsonBlock;
    slot?: ReactNode;
}

/** 详情 JSON 区块标题，保留 sectionTitle/sectionSlot 两种配置。 */
export function TitleBlock({ item, slot }: TitleBlockProps) {
    if (!item.sectionTitle && !slot) return null;
    return (
        <div className="detail-json__block-title">
            {slot ?? <div className="detail-json__section-title">{item.sectionTitle}</div>}
        </div>
    );
}

export default TitleBlock;
